import React from 'react';
import { InputNumber } from '@components/framework/input/InputNumber';
import CurrencyDropdown from '@components/ringil3/Input/InputPriceWithCurrency/CurrencyDropdown';
import { LovWithoutIdDTO } from '@api/ringil-api.v2';

interface InputPriceWithCurrencyProps {
  value: number;
  currency: string;
  disabled?: boolean;
  disabledCurrency?: boolean;
  changePrice: (price: number) => void;
  changeCurrency: (currencyCode: string) => void;
  code?: string;
  currencies?: LovWithoutIdDTO[];
  companyId?: string;
  dataTestId?: string;
  dataTestIdCurrency?: string;
}

const InputPriceWithCurrency: React.FC<InputPriceWithCurrencyProps> = ({
                                                                         currency,
                                                                         value,
                                                                         changePrice,
                                                                         changeCurrency,
                                                                         code,
                                                                         disabled = false,
                                                                         disabledCurrency = false,
                                                                         currencies,
                                                                         companyId,
                                                                         dataTestId,
                                                                         dataTestIdCurrency,
                                                          }) => {
  return (
    <>
      <div className={'flex flex-row w-full'} data-testid={dataTestId}>
        <InputNumber
          className="p-text-right"
          minFractionDigits={2}
          maxFractionDigits={2}
          value={value}
          onValueChange={e => changePrice(e.value)}
          mode="decimal"
          disabled={disabled}
          locale={'cs'}
          inputStyle={{ textAlign: 'right', borderRight: 'none', width: '100%' }}
          style={{ width: '100%' }}
        />
        <CurrencyDropdown
          selectedCurrency={currency}
          companyId={companyId}
          onSelected={value => changeCurrency(value)}
          disabled={disabled || disabledCurrency}
          required={true}
          code={code}
          currencies={currencies}
          dataTestId={dataTestIdCurrency}
        />
      </div>
    </>
  );
};

export default InputPriceWithCurrency;
